import { render, staticRenderFns } from "./collectiondtl.vue?vue&type=template&id=553d2222&scoped=true&"
import script from "./collectiondtl.vue?vue&type=script&lang=js&"
export * from "./collectiondtl.vue?vue&type=script&lang=js&"
import style0 from "./collectiondtl.vue?vue&type=style&index=0&id=553d2222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d2222",
  null
  
)

export default component.exports